import { SystemVersionListResponse } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export function useLatestSystemVersion() {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<SystemVersionListResponse>(
    token ? `/api/system-versions?page=1&pageSize=1&sortBy=update_id&sortOrder=desc&tag=tv` : null,
    undefined,
    token ?? '',
  )

  return {
    latestVersion: data?.data?.items?.[0] || null,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
